import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "@env/environment";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { EvalLead, EvalLeadFilter, EvalLeadsResponse, EvalLeadSummary } from "@app-model/eval-lead";
import { FilterOptions } from "./open.service";
import { City } from "@app-model/city";

@Injectable({
  providedIn: "root",
})
export class EvalLeadService {
  constructor(private http: HttpClient) { }

  search(
    filter: EvalLeadFilter
  ): Observable<EvalLeadsResponse> {
    return this.http
      .post(`${environment.api}/evalLead/search`, filter)
      .pipe(map((response: EvalLeadsResponse) => response));
  }

  getFilterOptions(filter: EvalLeadFilter): Observable<FilterOptions> {
    return this.http
      .post(`${environment.api}/evalLead/filterOptions`, filter)
      .pipe(map((response: FilterOptions) => response));
  }

  searchCitiesByName(query: string, filter: EvalLeadFilter): Observable<City[]> {
    return this.http
      .post(`${environment.api}/evalLead/cityOptions?query=${query}`, filter)
      .pipe(map((response: City[]) => response));
  }

  archive(leadId: string, reason?: string) {
    return this.http.post(
      `${environment.api}/evalLead/archive/${leadId}?reason=${reason}`,
      null
    );
  }

  getSummary(filter: EvalLeadFilter): Observable<EvalLeadSummary> {
    return this.http.post(`${environment.api}/evalLead/summary`, filter)
      .pipe(map((response: EvalLeadSummary) => response));
  }


  downloadCSV(filter: EvalLeadFilter) {
    return this.http.post(
      `${environment.api}/evalLead/downloadCSV`,
      filter,
      {
        headers: new HttpHeaders({
          Accept: 'application/csv',
        }),
        responseType: 'blob' as 'json',
      }
    );
  }
}
